import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
/* TODO: Extend component from @scalefast/components when package updated */
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormsModule } from '@angular/forms';
import { NgClass, TitleCasePipe } from '@angular/common';

@Component({
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          gridTemplateRows: '1fr',
        }),
      ),
      state(
        'closed',
        style({
          gridTemplateRows: '0fr',
        }),
      ),
      transition('open => closed', [animate('.2s')]),
      transition('closed => open', [animate('.2s')]),
    ]),
  ],
  selector: 'app-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.scss'],
  standalone: true,
  imports: [NgClass, TitleCasePipe, FormsModule],
})
export class AppSelectDropdownComponent implements OnInit {
  @Input() list: any;
  @Input() name = '';
  @Output() shareValueSelected = new EventEmitter();

  selectedOption = '';
  selectedOptionLabel = '';
  showDropDown = false;

  ngOnInit(): void {
    this.loadActiveValues();
  }

  loadActiveValues() {
    this.list.map((item: any) => {
      if (item.checked) {
        this.name = item.label;
        this.selectedOption = item.value;
        this.selectedOptionLabel = item.label;
      }
    });
  }

  getSelectedValue(option: any) {
    this.selectedOption = option.value;
    this.selectedOptionLabel = option.label;
    this.list.map((item: any) => {
      if (item.value !== option.value) {
        item.checked = false;
      }
    });
    option.checked = true;
    this.shareSelectedValue();
  }

  shareSelectedValue() {
    this.shareValueSelected.emit([{ label: this.selectedOptionLabel, value: [this.selectedOption] }]);
  }
}
